import { render, staticRenderFns } from "./onlineSeminars.vue?vue&type=template&id=1960ed88&"
import script from "./onlineSeminars.vue?vue&type=script&lang=js&"
export * from "./onlineSeminars.vue?vue&type=script&lang=js&"
import style0 from "./onlineSeminars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports